(function () {
  'use strict';

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function init(root) {
    if (!root || root.dataset.bhmReady === 'true') return;

    var track = root.querySelector('[data-bhm-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bhm-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bhm-tab]'));

    if (!track || !slides.length || !tabs.length) return;

    root.dataset.bhmReady = 'true';

    var scrolling = false;

    function nearestIndex() {
      var left = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;

      slides.forEach(function (slide, index) {
        var dist = Math.abs(slide.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = index;
        }
      });

      return best;
    }

    function markActive(index) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });

      return index;
    }

    function setActive(index, smooth) {
      index = markActive(index);
      var behavior = smooth && !prefersReducedMotion() ? 'smooth' : 'auto';
      scrolling = true;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: behavior });
      window.setTimeout(function () {
        scrolling = false;
      }, smooth ? 480 : 60);
    }

    function activateHotspot(slide, id) {
      Array.prototype.forEach.call(slide.querySelectorAll('[data-bhm-hotspot]'), function (el) {
        var on = el.getAttribute('data-bhm-hotspot') === id;
        el.classList.toggle('is-active', on);
        if (el.hasAttribute('aria-pressed')) {
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      });
      Array.prototype.forEach.call(slide.querySelectorAll('[data-bhm-cards]'), function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-bhm-cards') === id);
      });
    }

    function onHotspotClick(event) {
      var trigger = event.target.closest('[data-bhm-hotspot]');
      if (!trigger || !root.contains(trigger)) return;
      var slide = trigger.closest('[data-bhm-slide]');
      if (!slide) return;
      activateHotspot(slide, trigger.getAttribute('data-bhm-hotspot'));
    }

    function onTabClick(event) {
      var tab = event.currentTarget;
      var index = tabs.indexOf(tab);
      if (index < 0) return;
      setActive(index, true);
    }

    function onKeydown(event) {
      var current = tabs.indexOf(document.activeElement);
      if (current < 0) return;

      var next = current;
      if (event.key === 'ArrowRight') next = current + 1;
      else if (event.key === 'ArrowLeft') next = current - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;

      event.preventDefault();
      if (next < 0) next = tabs.length - 1;
      if (next > tabs.length - 1) next = 0;
      tabs[next].focus();
      setActive(next, true);
    }

    function onScroll() {
      if (scrolling) return;
      markActive(nearestIndex());
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', onTabClick);
    });
    root.addEventListener('click', onHotspotClick);

    var tablist = root.querySelector('[data-bhm-tabs]');
    if (tablist) tablist.addEventListener('keydown', onKeydown);
    track.addEventListener('scroll', onScroll, { passive: true });

    var start = 0;
    slides.forEach(function (slide, i) {
      if (slide.classList.contains('is-active')) start = i;
    });
    setActive(start, false);

    root._bhmDestroy = function () {
      tabs.forEach(function (tab) {
        tab.removeEventListener('click', onTabClick);
      });
      root.removeEventListener('click', onHotspotClick);
      if (tablist) tablist.removeEventListener('keydown', onKeydown);
      track.removeEventListener('scroll', onScroll);
      delete root.dataset.bhmReady;
    };
  }

  function boot(scope) {
    var nodes = scope.querySelectorAll('[data-bhm]');
    Array.prototype.forEach.call(nodes, init);
  }

  function bootTarget(event) {
    if (!event || !event.target) return;
    if (event.target.matches && event.target.matches('[data-bhm]')) {
      init(event.target);
      return;
    }
    boot(event.target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', bootTarget);
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    var root = event.target.matches && event.target.matches('[data-bhm]')
      ? event.target
      : event.target.querySelector('[data-bhm]');
    if (root && root._bhmDestroy) root._bhmDestroy();
  });
})();
